module.exports = __webpack_public_path__ + "static/media/impmsLogo.87c0abe4.webp";